var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.team.content_enabled)?_c('v-card',{staticClass:"mb-4"},[_c('v-card-title',[_vm._v("\n    Other Settings\n  ")]),_vm._v(" "),_c('v-simple-table',[_c('tbody',[_c('tr',[_c('td',[_vm._v("\n        iOS Settings\n      ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n        PDF View Mode\n      ")])])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }